import SignOutButton from './SignOutButton';

export default SignOutButton;
